import { render, staticRenderFns } from "./CreateCrashLetterModal.vue?vue&type=template&id=176ed1aa&"
import script from "./CreateCrashLetterModal.vue?vue&type=script&lang=js&"
export * from "./CreateCrashLetterModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateCrashLetterModal.vue?vue&type=style&index=0&id=176ed1aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports